// crypto.js — XChaCha20-Poly1305 via libsodium-wrappers

export async function sodiumReady() {
  await window.sodium.ready;
  return window.sodium;
}

export async function encrypt(plaintext) {
  const na = await sodiumReady();
  const key = na.crypto_secretstream_xchacha20poly1305_keygen();
  const { state, header } = na.crypto_secretstream_xchacha20poly1305_init_push(key);
  const cipher = na.crypto_secretstream_xchacha20poly1305_push(
    state,
    na.from_string(plaintext),
    null,
    na.crypto_secretstream_xchacha20poly1305_TAG_FINAL
  );
  // Pack: header (24 bytes) || ciphertext
  const blob = new Uint8Array(header.length + cipher.length);
  blob.set(header, 0);
  blob.set(cipher, header.length);
  return {
    ciphertext: na.to_base64(blob, na.base64_variants.URLSAFE_NO_PADDING),
    key: na.to_base64(key, na.base64_variants.URLSAFE_NO_PADDING),
  };
}

export async function decrypt(ciphertextB64, keyB64) {
  const na = await sodiumReady();
  const key = na.from_base64(keyB64, na.base64_variants.URLSAFE_NO_PADDING);
  const blob = na.from_base64(ciphertextB64, na.base64_variants.URLSAFE_NO_PADDING);
  const headerLen = na.crypto_secretstream_xchacha20poly1305_HEADERBYTES;
  const header = blob.slice(0, headerLen);
  const cipher = blob.slice(headerLen);
  // Asymmetric API: init_push returns { state, header }, but init_pull returns
  // the state itself. Destructuring `{ state }` here yielded undefined and made
  // every decryption throw.
  const state = na.crypto_secretstream_xchacha20poly1305_init_pull(header, key);
  const result = na.crypto_secretstream_xchacha20poly1305_pull(state, cipher, null);
  if (!result) throw new Error('Decryption failed');
  return na.to_string(result.message);
}
